import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubtleBadge from "components/common/SubtleBadge";
import useFormattedDate from "hooks/useFormatDate";
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

export const ApiKeyDetailsModal = ({
  selectedKey,
  loading,
  showModal,
  setShowModal,
}) => {
  const { formatDateTime } = useFormattedDate();

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        API Key Details
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.8rem" }}>
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: 120 }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : selectedKey ? (
          <>
            <p className="medium">
              <strong>Name:</strong> {selectedKey.name}
            </p>
            <p>
              <strong>API Key:</strong> {selectedKey.id}
            </p>
            <p>
              <strong>Client ID:</strong> {selectedKey.clientId}
            </p>

            <p>
              <strong>Key:</strong> {selectedKey.key}
            </p>
            <div className="d-flex gap-2 mb-3">
              <strong>Status:</strong>{" "}
              {selectedKey.active ? (
                <SubtleBadge pill bg="success" className="d-block">
                  ACTIVE
                  <FontAwesomeIcon
                    icon="check"
                    transform="shrink-2"
                    className="ms-1"
                  />
                </SubtleBadge>
              ) : (
                <SubtleBadge pill bg="secondary" className="d-block">
                  DISABLED
                  <FontAwesomeIcon
                    icon="ban"
                    transform="shrink-2"
                    className="ms-1"
                  />
                </SubtleBadge>
              )}
            </div>
            <p>
              <strong>ExpiresAt:</strong>{" "}
              {formatDateTime(selectedKey.expiresAt)}
            </p>

            <p>
              <strong>Description:</strong> {selectedKey.description}
            </p>
            <p>
              <strong>UpdatedAt:</strong>{" "}
              {formatDateTime(selectedKey.updatedAt) || "NULL"}
            </p>
            <p>
              <strong>UpdatedBy:</strong> {selectedKey.updatedBy || "NULL"}
            </p>
          </>
        ) : (
          <p>No data</p>
        )}
      </Modal.Body>
      <Modal.Footer className="border-none">
        <Button
          size="sm"
          variant="secondary"
          onClick={() => setShowModal(false)}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
